export const PROJECT_MENU_PERMISSION_KEYS = {
  DASHBOARD: 'DASHBOARD_MENU',
  EQUIPMENT: 'EQUIPMENT_MENU',
  TASKS: 'TASKS_MENU',
  PLANS: 'PLANS_MENU',
  PHOTOS: 'PHOTOS_MENU',
  FORMS: 'FORMS_MENU',
  FILES: 'FILES_MENU',
  BLOCK_SCHEDULE: 'BLOCK_SCHEDULE_MENU',
  PROJECT_USERS: 'PROJECT_USERS_MENU',
  TEMPLATES: 'TEMPLATES_MENU',
  INTEGRATIONS: 'INTEGRATIONS_MENU',
  SETTINGS: 'SETTINGS_MENU',
} as const;
